import { Component, Inject, OnInit, NgZone, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { UserService } from "../../services/user.service";
import { Token } from "../../models/token.model";
import { GapiServiceService } from "../../services/gapi-service.service";
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment.prod';
declare var window: any;

@Component({
  selector: 'login-externalproviders',
  templateUrl: './login-externalproviders.component.html',
  styleUrls: ['./login-externalproviders.component.css']
})
export class LoginExternalprovidersComponent implements OnInit {
  externalProviderWindow: any;
  useGoogleDrive:boolean;

  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService,
    // inject the local zone
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject('BASE_URL') private baseUrl: string,
    private gapiService: GapiServiceService,
    private notificationsService: ToastrService,
  ) { 
    this.useGoogleDrive = environment.useGdrive;
  }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    // close previously opened windows (if any)
    this.closePopUpWindow();
    // instantiate the externalProviderLogin function
    // (if it doesn't exist already)
    var self = this;
    if (!window.externalProviderLogin) {
      window.externalProviderLogin = function (auth:
        Token) {
        self.zone.run(() => {
          self.userService.setAuth(auth);
          self.router.navigate([""]);
        });
      }
    }
  }
  closePopUpWindow() {
    if (this.externalProviderWindow) {
      this.externalProviderWindow.close();
    }
    this.externalProviderWindow = null;
  }
  callExternalLogin(providerName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    var url = this.baseUrl + "Account/ExternalLogin/" +
      providerName;
    // minimalistic mobile devices support
    var w = (screen.width >= 1050) ? 1050 : screen.width;
    var h = (screen.height >= 550) ? 550 : screen.height;
    var params = "toolbar=yes,scrollbars=yes,resizable=yes,width="
      + w + ", height=" + h;
    // close previously opened windows (if any)
    this.closePopUpWindow();
    this.externalProviderWindow = window.open(url, "ExternalProvider", params, false);
  }
  onGoogleLogin(){
    if(!this.gapiService.isGoogle)
    {
      return;
    }
    this.gapiService.signIn().then((user:gapi.auth2.BasicProfile) => {
      this.gapiService.initRootFolder();
      let tokenData = this.gapiService.getTokenData();
      let email = user.getEmail();
      let token = tokenData.access_token;
      this.userService.loginWithGoogle(email,token).subscribe(
        (data: any) => {
        this.notificationsService.success("User authenticated");
        this.router.navigate(["home"]);
        },
        (error) => {
          this.notificationsService.error(error.statusText);
        }
      );
  });
  }
}
